export default "__VITE_ASSET__720e67d4__"